export default __webpack_public_path__ + "static/media/calendarWhite.d3fbd147.svg";